import React from 'react';
import { IconProps } from './types';

export const FileFilledIcon = (props: IconProps) => {
  const { size = 16, color = 'currentColor', style = {} } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
    >
      <path
        fill={color}
        d='M14.5 1.5c-.1-.2-.3-.2-.3-.2H14 6C4.5 1.3 3.3 2.5 3.3 4v16c0 1.5 1.2 2.7 2.7 2.7h12c1.5 0 2.7-1.2 2.7-2.7V8c0-.1-.2-.3-.2-.4l-6-6.1zm.5 14.7H9c-.6 0-1.2-.6-1.2-1.2s.6-1.2 1.2-1.2h6c.6 0 1.2.6 1.2 1.2s-.6 1.2-1.2 1.2zm-.3-9V3.8l3.5 3.4h-3.5z'
      />
    </svg>
  );
};
